import React from "react";
import styled from '@emotion/styled';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';

const ImageTitle = ({ image, title, subtitle, subtitle2 }) => {

  const ImgDiv = styled.div`
    width: 100%;
    height: 15em;
    display: flex;
    align-items: center;
    overflow: hidden;
    justify-content: center;
    margin-bottom: 25px;
  `;

  const BlackDiv = styled.div`
    background: linear-gradient(to right, rgba(0,0,0,0.6), rgba(0,0,0,0.2), rgba(0,0,0,0.6));
    height: 15em;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 10;
    position: absolute;
  `;

  const Title = styled.p`
    font-family: "League Gothic", serif;
    font-size: 80px;
    color: white;
    margin: 0px;
  `;

  const SubTitle = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: #12b854;
    margin: 0px;
    font-weight: 700;
  `;
  
  const SubTitle2 = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: #ff914d;
    margin: 0px;
    font-weight: 700;

    
  `;

  // Detectar si es móvil o no
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <ImgDiv>
        <ParallaxProvider>
          {/* Aquí asignamos speed={0} en pantallas pequeñas, de lo contrario sigue con -200 */}
          <Parallax speed={isMobile ? 0 : -200}>
            <img src={image} alt="Parallax" style={{ width: '100%' }} />
          </Parallax>
        </ParallaxProvider>
        <BlackDiv>
          <Title>{title}</Title>
          <SubTitle>{subtitle}</SubTitle>
          <SubTitle2>{subtitle2}</SubTitle2>
        </BlackDiv>
      </ImgDiv>
    </>
  );
};

export default ImageTitle;
